<div
    class="time-reclaimed-card relative rounded-[20px] shadow-[0_-6px_16px_-4px_rgba(0,0,0,0.1),0_6px_16px_-4px_rgba(0,0,0,0.1)] text-white p-4 h-full overflow-hidden flex flex-col gap-2 min-w-0">

    <div class="flex items-center justify-between gap-2 flex-wrap shrink-0">
        <div class="flex items-center gap-2 font-semibold text-[16px] glass-card px-3 py-1 rounded-full ">
            <app-icon type="zap"></app-icon>
            <span>Time reclaimed by AI</span>
            <app-icon type="info" class="opacity-70" pTooltip="Displays the estimated time saved through AI automation"
                tooltipPosition="top"></app-icon>
        </div>
        @if (loading()) {
        <p-skeleton width="7.5rem" height="1.75rem" borderRadius="62.4375rem" class="skeleton-on-dark"></p-skeleton>
        } @else {
        <div class="flex items-center gap-2 px-3 py-1 rounded-full bg-white/15 text-xs glass-card "
            pTooltip="Estimated cost saved based on a standard hourly rate" tooltipPosition="top">
            <app-icon type="circle-dollar-sign"></app-icon>
            <span class="text-sm font-semibold">${{ formatCost(data()?.costSaved ?? 0) }}</span>
            <span class="text-xs opacity-70">cost saved</span>
            <app-icon type="info" class="opacity-70"></app-icon>
        </div>
        }
    </div>

    @if (loading()) {
    <!-- Skeleton: reclaimed hours -->
    <div class="flex flex-col items-center justify-center gap-2 shrink-0">
        <p-skeleton width="5rem" height="0.75rem" class="skeleton-on-dark"></p-skeleton>
        <p-skeleton width="8.75rem" height="2.25rem" class="skeleton-on-dark"></p-skeleton>
    </div>

    <!-- Skeleton: donut chart -->
    <div class="flex-1 min-h-[8.75rem] flex items-center justify-center overflow-hidden">
        <p-skeleton shape="circle" width="11.25rem" height="11.25rem" class="skeleton-on-dark"></p-skeleton>
    </div>

    <!-- Skeleton: breakdown chips -->
    <div class="flex gap-2 shrink-0 overflow-hidden pb-1 mt-2">
        <p-skeleton *ngFor="let i of [0, 1, 2, 3]" width="6.875rem" height="4rem" borderRadius="0.75rem"
            class="skeleton-on-dark flex-shrink-0"></p-skeleton>
    </div>
    } @else {
    <div class="text-center shrink-0">
        <div class="flex flex-col items-center justify-center gap-2">
            <div class="text-[13px]">Reclaimed</div>
            <div class="leading-none">
                <span class="text-3xl  font-[700] tracking-[-2px]">
                    {{ formatHours(data()?.reclaimedHours ?? 0) }}
                </span>
                <span class="text-[26px] font-semibold ">hrs</span>
            </div>
        </div>

        <!-- Comparison row
            @if (pctChange() !== null) {
            <div class="flex items-center justify-center gap-2 mt-2 text-sm text-white/70">
                <span>
                    {{ (hoursDiff() ?? 0) >= 0 ? '+' : '' }}{{ hoursDiff() | number:'1.1-1' }} hrs vs last month
                </span>
                <span class="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold"
                    [class]="(pctChange() ?? 0) >= 0 ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'">
                    <app-icon [type]="(pctChange() ?? 0) >= 0 ? 'arrow-up' : 'arrow-down'" [size]="'xs'"></app-icon>
                    {{ (pctChange() ?? 0) | number:'1.1-1' }}%
                </span>
            </div>
            } -->
    </div>


    <div class="flex-1 min-h-[140px] relative overflow-hidden">
        <div echarts [options]="chartOption()" class="absolute inset-x-0 bottom-0 h-[200%]"></div>
    </div>


    <div class="flex gap-2 shrink-0 overflow-x-auto scrollbar-thin pb-1 mt-2">
        @for (item of breakdownWithColors(); track item.threadType) {
        <div class="rounded-xl px-3 py-2 flex-shrink-0 min-w-[110px] glass-card ">
            <div class="flex items-center gap-1.5 text-[0.7rem] opacity-80">
                <span class="inline-block w-2 h-2 rounded-full flex-shrink-0"
                    [style.background-color]="item.color"></span>
                <span class="truncate">{{ item.label }}</span>
            </div>
            <div class="text-sm font-semibold mt-1">
                {{ item.hoursReclaimed | number:'1.1-2' }} hrs
            </div>
            <div class="text-[0.65rem] opacity-60">of {{ formatHours(data()?.manualHours ?? 0) }} reclaimed hours</div>
        </div>
        }
    </div>
    }

</div>